<template>
  <div class="star-warp">
    <div class="title">
        <div class="right" @click="duihuan">确认兑换</div>
        <div class="text">兑换好礼星星</div>

        
    </div>
    <div class="star-list">
        <star-item v-for="item in starList" ref="starItem" :key="item.description" :data="item"/>
    </div>
  </div>
</template>

<script>
import starItem from './starItem.vue'
export default {
  components: { starItem },
    props:['data'],
    data(){
        var list = JSON.parse(JSON.stringify(this.data));
        return {
            starList:list
        }
    },
    methods:{
        duihuan(){
            var  v = [];
            var starList = this.$refs['starItem'] || [];
            for(var item of starList){
                if(item.num>0){
                    v.push({"qty":item.num,"star_unit":item.data['star_unit']});
                }
            }
            this.$emit("starCb",v);
        }
    }
}
</script>

<style lang="scss" scoped>
.star-warp{
    height: 100%;
    display: flex;
    flex-direction: column;

    .title{
        box-shadow: 0 0 20px rgba(0,0,0,0.1);
        height: 88px;
        line-height: 88px;
        position: relative;

        .text{
            text-align: center;
            font-weight: bold;
        }

        .right{
            position: absolute;
            top: 0;
            right: 20px;
            color: #00af66;
        }
    }

    .star-list{
        flex: 1;
        min-height: 0;
        overflow: auto;
    }
}
</style>
